<template>
    <div class="main">
        <ReferralBanner />
        <div class="mt-8"></div>
        <ReferralSteps />
        <div class="mt-8"></div>
        <ReferralCode />
        <div class="mt-8"></div>
        <ReelsAndShorts />
        <div class="mt-8"></div>
    </div>
</template>


<script>


import ReferralCode from '../components/Referral/Referral-Code.vue';
import ReferralSteps from '../components/Referral/Referral-Steps.vue';
import ReferralBanner from '../components/Referral/Referral-Banner.vue';
import ReelsAndShorts from '../components/Referral/Reels-and-Shorts.vue';

export default {
    name: "ReferralComponent",
    components: {
        ReferralCode,
        ReferralSteps,
        ReelsAndShorts,
        ReferralBanner,
    }
};
</script>
